__turbopack_context__.v({
  "buttons": "BGsAtW_buttons",
  "content": "BGsAtW_content",
  "shimmer": "BGsAtW_shimmer",
  "text": "BGsAtW_text",
  "text-bar-sweep": "BGsAtW_text-bar-sweep",
});
